<template>
  <v-card>
    <v-card-title>
      <span class="text-h5">
        {{ $t('ITEM.ADD') }} {{ $t('HOLIDAY.ITEM') }}
      </span>

      <v-spacer />

      <v-btn icon @click="cancel">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-form ref="form" v-model="valid" lazy-validation>
        <holiday-form
          v-model="form"
          :errors="errors.getAll()"
          @update-prop="clearErrorByName($event)"
        />
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-btn outlined depressed color="grey" @click="cancel">
        {{ $t('BUTTON.CANCEL') }}
      </v-btn>

      <v-spacer />

      <v-btn depressed color="primary" :disabled="!valid" @click="create">
        {{ $t('BUTTON.CREATE') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import errors from '@/modules/_global/mixins/errors';
import HolidayForm from './forms/HolidayForm.vue';
import { HolidaysService } from '@/services/holidays.service';

export default {
  name: 'CreateHoliday',

  components: {
    HolidayForm
  },

  mixins: [errors],

  data() {
    return {
      valid: true,
      form: {
        date: null,
        title: ''
      }
    };
  },

  methods: {
    cancel() {
      this.$emit('cancel');
    },

    create() {
      if (!this.$refs.form.validate()) {
        return;
      }

      HolidaysService.create(this.form)
        .then(({ data }) => {
          this.$store.commit('snackbar/setSnack', {
            status: 'success',
            text: this.$t('MESSAGE.SUCCESS')
          });
          this.$emit('created', data.data);
        })
        .catch(this.handleErrors);
    }
  }
};
</script>
